import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import { SearchService } from '../../services/search/search.service';
@Component({
  selector: 'app-master-auto',
  templateUrl: './master-auto.component.html',
  styleUrls: ['./master-auto.component.scss']
})
export class MasterAutoComponent implements OnInit {

  @Input() header: string;
  @Input() required: false;
  @Input() data: any;
  @Input() entity: any;
  @Input() metadata: any;
  @Input() name: any;
  @Input() rf: any;
  @Input() display: any;


  @Output() selectItem = new EventEmitter();

  searching = null;

  constructor(private searchService: SearchService) { }

  ngOnInit() {
  }

  onSelect(e) {
    this.selectItem.emit(e);
  }


  doSearch = (text$: Observable<string>) => {

    return text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => this.searching = 'candidate'),
      switchMap(term => {
        return this.searchService
          .search(this.entity, term, this.metadata)
          .pipe(
            map(res => res['data'] || res)
          )
      }),
      tap(() => this.searching = ''),
    );

  };



  formatInput = (e) => {

    if (!e) {
      return "";
    }
    if (this.display) {
      var ans = this.display;
      for (var x in e) {
        var re = new RegExp("#" + x, "g");
        ans = ans.replace(re, e[x]);
      }
      return ans;
    }


    if (e.center_id) {
      return e.center_id;
    }
    return "";

  }


}
